export default "__VITE_ASSET__Sb3wI45f__"